import { useMediaQuery, useTheme } from '@mui/material';

const useIsLargerThan = (size) => {
  const theme = useTheme();
  const isLarger = useMediaQuery(theme.breakpoints.up(size));

  return isLarger;
};

export default useIsLargerThan;
